import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";

export const BottomCTA = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 lg:py-28 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0C2340] to-[#1B3A5C]" />
      
      {/* Decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#C8A24D]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#C8A24D]/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center section-reveal">
        <div className="w-16 h-16 rounded-2xl bg-[#C8A24D]/20 flex items-center justify-center mx-auto mb-8">
          <ArrowRight className="w-8 h-8 text-[#E8D5A0]" />
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-white leading-tight mb-6" style={{ fontFamily: "'DM Serif Display', serif" }}>
          {t("bottomCta.title")}
        </h2>
        <p className="text-lg sm:text-xl text-white/70 leading-relaxed mb-10 max-w-2xl mx-auto">
          {t("bottomCta.subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            className="bg-[#C8A24D] hover:bg-[#B8920D] text-[#0C2340] font-semibold h-14 px-10 text-base rounded-xl shadow-xl shadow-[#C8A24D]/25 transition-all duration-300 hover:shadow-2xl hover:shadow-[#C8A24D]/30 group"
            onClick={() => document.getElementById('viabilidad')?.scrollIntoView({ behavior: 'smooth' })}
          >
            {t("bottomCta.btn1")}
            <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
          <a
            href={`tel:${t("footer.phone")}`}
            className="inline-flex items-center border border-white/20 text-white bg-white/5 hover:bg-white/10 h-14 px-8 text-base rounded-xl backdrop-blur-sm transition-all"
          >
            <Phone className="w-4 h-4 mr-2 text-[#C8A24D]" />
            {t("footer.phone")}
          </a>
          <a
            href={`https://wa.me/${t("footer.phone").replace(/\+/g, "").replace(/\s/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold h-14 px-10 text-base rounded-xl shadow-xl shadow-[#25D366]/20 transition-all duration-300"
          >
            {t("bottomCta.whatsapp")}
          </a>
        </div>

        <p className="text-white/40 text-sm mt-8">
          {t("bottomCta.footerInfo")}
        </p>
      </div>
    </section>
  );
};

export default BottomCTA;
